import { render, staticRenderFns } from "./ExistingCandidates.vue?vue&type=template&id=2ea5e17f&"
import script from "./ExistingCandidates.vue?vue&type=script&lang=js&"
export * from "./ExistingCandidates.vue?vue&type=script&lang=js&"
import style0 from "./ExistingCandidates.vue?vue&type=style&index=0&id=2ea5e17f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports